<template>
  <div v-if="loaded" class="questionsPage">
    <VSnackbar v-model="dialog" :timeout="0" :top="true"
    >Network Error. Reconnecting in {{ reconnectTime }} secs
    </VSnackbar
    >
    <InternetLostPopUp v-show="dialog"></InternetLostPopUp>
    <FullScreen
      v-if="!dialog && showModal"
      @close="showModal = false"
    ></FullScreen>
    <EndTest
      v-if="$store.state.showPopup"
      :mcqs="mcqs"
      :prog="Programming"
      :sub="Subjective"
      @close="$store.state.showPopup = false"
    ></EndTest>
    <ProctoringStream v-if="$store.state.cameraEnabled || $store.state.micEnabled"></ProctoringStream>
    <QuestionMap
      v-show="showSidePanes"
      :mcqs="mcqs"
      :prog="Programming"
      :sub="Subjective"
      :current-section="currentSection"
      @changeSection="changeSection"
      @changeCurrent="changeCurrent"
    ></QuestionMap>
    <QuestionsList
      v-show="showSidePanes"
      :mcqs="getQuestionList"
      @changeCurrent="changeCurrent"
    ></QuestionsList>
    <QuestionDetail
      :total="this.mcqs.total"
      :curr-question="getCurrentQuestion"
      @onSubmitButtonPressed="onSubmitButtonPressed"
      @onMarkForReviewButtonPressed="onMarkForReviewButtonPressed"
      @onNextButtonPressed="onNextButtonPressed"
      @decTotal="decTotal"
      @hideSidePanes="hideSidePanes"
      @increaseTotalProgrammingSubmitted="increaseTotalProgrammingSubmitted"
    ></QuestionDetail>
    <SwitchTabPopup
      v-if="showSwitchTab && $store.state.proctoringEventCount > 0"
      :switchCount="$store.state.proctoringEventCount"
      @close="showSwitchTab = false"
    ></SwitchTabPopup>
  </div>
</template>

<script>
import QuestionsList from './QuestionsList'
import QuestionMap from './QuestionMap'
import QuestionDetail from './QuestionDetail'
import FullScreen from '../components/FullScreen.vue'
import EndTest from '../components/EndTestPopUp.vue'
import api from '../services/api.service'
import {mapState, mapActions} from 'vuex'
import Axios from 'axios'
import SwitchTabPopup from './SwitchTabPopup'
import InternetLostPopUp from './InternetLostPopUp'
import ProctoringStream from '../views/ProctoringStream.vue'
import TestViolatePopup from './TestViolatePopup.vue'

export default {
  name: 'QuestionsPage',
  components: {
    InternetLostPopUp,
    SwitchTabPopup,
    QuestionsList,
    QuestionMap,
    QuestionDetail,
    FullScreen,
    EndTest,
    ProctoringStream,
    TestViolatePopup
  },
  computed: mapState({
    test_id: state => state.test.testId,
    user_id: state => state.userId,

    getCurrentQuestion: function () {
      if (this.currentSection === 'mcqs') {
        return this.mcqs.questions[this.mcqs.current]
      } else if (this.currentSection === 'Subjective') {
        return this.Subjective.questions[this.Subjective.current]
      } else {
        return this.Programming.questions[this.Programming.current]
      }
    },
    getQuestionList: function () {
      if (this.currentSection === 'mcqs') {
        return this.mcqs
      } else if (this.currentSection === 'Subjective') {
        return this.Subjective
      } else {
        return this.Programming
      }
    },
    getTotal: function () {
      if (this.currentSection === 'mcqs') {
        return this.mcqs.total
      } else if (this.currentSection === 'Subjective') {
        return this.Subjective.total
      } else {
        return this.Programming.total
      }
    },
  }),
  methods: {
    countdown() {
      if (this.reconnectTime >= 1) {
        this.reconnectTime--
      } else {
        this.reconnectTime = 10
      }
    },
    ...mapActions(['endTest']),
    decTotal() {
      if (
        this[this.currentSection].questions[this[this.currentSection].current]
          .currentClass === 'saved' ||
        this[this.currentSection].questions[this[this.currentSection].current]
          .currentClass === 'reviewSubmit'
      ) {
        this[this.currentSection].totalSaved =
          this[this.currentSection].totalSaved - 1
      }
    },
    startClock() {
      this.$store.commit(
        'setTimer',
        setInterval(() => {
          this.$store.commit('durationLeftDecrement')
          sessionStorage.durationLeft = this.$store.state.test.durationLeft
          if (this.$store.state.test.durationLeft === 0) {
            clearInterval(this.$store.state.timer)
            this.endTest(this.$router)
          }
        }, 1000)
      )
    },
    changeCurrent: function (newCurrent) {
      this[this.currentSection].current = newCurrent
    },
    nextQuestion: function () {
      if (
        this[this.currentSection].current ===
        this[this.currentSection].total - 1
      ) {
        if (this.currentSection === 'mcqs') {
          this.Programming.total > 0 && (this.currentSection = 'Programming')
          this[this.currentSection].current = 0
          return
        }
        if (this.currentSection === 'Programming') {
          this[this.currentSection].current = 0
          return
        }
        if (this.currentSection === 'Subjective') {
          this[this.currentSection].current = 0
        }
      } else {
        this[this.currentSection].current =
          this[this.currentSection].current + 1
      }
    },
    onSubmitButtonPressed: function () {
      console.log(this.currentSection)
      console.log(this[this.currentSection].current)
      var temp = this[this.currentSection].current
      var tempSection = this.currentSection
      console.log(
        this[this.currentSection].questions[this[this.currentSection].current]
          .currentClass
      )

      console.log(this.buildAnswer(temp, tempSection))
      api
        .submitAnswer(
          this.test_id,
          this.user_id,
          this.buildAnswer(temp, tempSection)
        )
        .then(() => {
          if (
            this[tempSection].questions[temp].currentClass !== 'saved' &&
            this[tempSection].questions[temp].currentClass !== 'reviewSubmit'
          ) {
            this[tempSection].totalSaved = this[tempSection].totalSaved + 1
          }
          this[tempSection].questions[temp].currentClass = 'saved'
          this[tempSection].questions[temp].saved = true
        })
      this.nextQuestion()
    },
    onMarkForReviewButtonPressed: function () {
      var temp = this[this.currentSection].current
      var tempSection = this.currentSection
      if (this.isAnswered(temp)) {
        if (
          this[tempSection].questions[temp].currentClass === 'saved' ||
          this[tempSection].questions[temp].currentClass === 'reviewSubmit'
        ) {
          this[tempSection].totalSaved = this[tempSection].totalSaved - 1
        }
        this[this.currentSection].questions[
          this[this.currentSection].current
          ].currentClass = 'review'
        var answerObj = this.buildAnswer(temp, tempSection)
        api
          .markForReviewUnanswered(this.test_id, this.user_id, answerObj)
          .then(() => {
            this[tempSection].questions[temp].saved = true
            this[tempSection].questions[temp].lastSavedAnswer = ''
          })
      } else {
        api
          .markForReview(
            this.test_id,
            this.user_id,
            this.buildAnswer(temp, tempSection)
          )
          .then(() => {
            if (
              this[tempSection].questions[temp].currentClass !== 'saved' &&
              this[tempSection].questions[temp].currentClass !== 'reviewSubmit'
            ) {
              this[tempSection].totalSaved = this[tempSection].totalSaved + 1
            }
            this[tempSection].questions[temp].saved = true
            this[tempSection].questions[temp].currentClass = 'reviewSubmit'
          })
      }
      console.log(
        this[this.currentSection].questions[this[this.currentSection].current]
          .currentClass
      )
      this.nextQuestion()
    },
    onNextButtonPressed: function () {
      this.showSidePanes = true
      this.nextQuestion()
    },
    changeSection: function (name) {
      console.log('asdfasfd')
      if (name === 'Multiple Choice Questions') {
        this.currentSection = 'mcqs'
      } else if (name === 'Programming') {
        this.currentSection = 'Programming'
      } else {
        this.currentSection = 'Subjective'
      }
    },
    buildAnswer: function (current, section) {
      console.log(current)
      console.log(section)
      console.log(this[section].questions[current])
      console.log(this[section])
      var answerObj = {}
      if (this[section].questions[current]._cls === 'MCQ') {
        var answerArr = []
        for (let [key, value] of Object.entries(
          this[section].questions[current].options
        )) {
          if (value.value) {
            this[section].questions[current].lastSavedAnswer = key
            answerArr.push(key.trimLeft())
          }
        }
        answerObj = {
          question_id: {
            id: this[section].questions[current]._id,
            cls: this[section].questions[current]._cls,
          },
          answer_type: 'MCQ',
          answer: answerArr,
        }
      } else if (this[section].questions[current]._cls === 'Subjective') {
        answerObj = {
          question_id: {
            id: this[section].questions[current]._id,
            cls: this[section].questions[current]._cls,
          },
          answer_type: 'Subjective',
          answer: this[section].questions[current].answer,
        }
      } else if (this[section].questions[current]._cls === 'Programming') {
        console.log()
      }
      return answerObj
    },
    exitHandler: function () {
      console.log('In Exit Handler')
      console.log(this.$store.state.timer)
      if (this.$store.state.timer === undefined) {
        this.startClock()
      }
      if (document.fullscreen === true || document.fullscreen === false) {
        this.showModal = !document.fullscreen
        console.log('in Fullscreen')
      } else if (
        document.webkitIsFullScreen === true ||
        document.webkitIsFullScreen === false
      ) {
        this.showModal = !document.webkitIsFullScreen
        console.log('in WebkitFullscreen')
      }
    },
    hideSidePanes() {
      this.showSidePanes = !this.showSidePanes
    },
    shuffle(array) {
      var currentIndex = array.length
      var temporaryValue
      var randomIndex
      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
      }
      console.log(array)
      return array
    },
    shuffleOptions(dict) {
      var array = []
      for (let [key, value] of Object.entries(dict)) {
        array.push([key, value])
      }
      array = this.shuffle(array)
      var options = {}
      for (var ele in array) {
        options[' ' + array[ele][0]] = array[ele][1]
      }
      console.log(options)
      return options
    },
    isAnswered(current) {
      var temp = false
      var currQuestion = this[this.currentSection].questions[current]
      if (currQuestion.options) {
        for (var value of Object.values(currQuestion.options)) {
          console.log(value.value)
          temp = temp || value.value
        }
      }
      if (currQuestion.answer && currQuestion.answer.length > 0) {
        temp = temp | true
      }
      return !temp
    },
    increaseTotalProgrammingSubmitted() {
      this.Programming.totalSaved = this.Programming.totalSaved + 1
    },
    onWindowFocusChange(e){
      let self = this
      console.log('count:' + self.$store.state.proctoringEventCount)
      if ({ focus: 1, pageshow: 1 }[e.type]) {
        // if visible
        if (this.inView) return;
        this.inView = true;
        console.log('visible')
      } else if (this.inView) {
        // if hidden
        this.inView = false;
        if(this.$store.state.detectCopyPaste == true){
          self.$store.state.allowCopy = false
        }
        if(this.$store.state.detectTabSwitch == true){
          self.$store.commit('countDecrement')

          api.postProctoringEvent(this.$route.params.test_id,this.user_id, 'TAB_SWITCH')
          self.showSwitchTab = true
        }
          console.log('hidden')
      }
      if (self.$store.state.proctoringEventCount == 0) {
        this.$store.commit('setCurrentStep' , 'test-rules-violated')
        this.$router.replace({ path: '/test-rules-violated' })
      }
    }
  },
  mounted: function () {
    if(this.$store.state.currentStep !== 'questions') {
      return;
    }
    sessionStorage.test_id = this.test_id
    sessionStorage.user_id = this.user_id

    this.showModal = true

    api.postTestee(this.test_id, this.user_id).then(response => {
        var testee_status = response['testee_status']
        if (testee_status === 'NOT_INVITED') {
          this.startTest = false
          this.$store.commit('setCurrentStep', 'error')
          this.$router.replace({path: '/error/4'})
        } else if (testee_status === 'STARTED') {
          this.startTest = false
          this.$store.commit('setCurrentStep', 'error')
          this.$router.replace({path: '/error/1'})
        } else if (testee_status === 'COMPLETED') {
          this.startTest = false
          this.$store.commit('setCurrentStep', 'error')
          this.$router.replace({path: '/error/2'})
        } else if (testee_status === 'TIME_COMPLETED') {
          this.startTest = false
          this.$store.commit('setCurrentStep', 'error')
          this.$router.replace({path: '/error/5'})
        }
        var questions = response['questions']
        for (var question of questions) {
          question['currentClass'] = 'normal'
          question['saved'] = true
          question['lastSavedAnswer'] = ''
          if (question._cls === 'MCQ') {
            question['number'] = this.mcqs.questions.length + 1
            question.options = this.shuffleOptions(question.options)
            this.mcqs.questions.push(question)
          } else if (question._cls === 'Subjective') {
            question['answer'] = ''
            question['number'] = this.Subjective.questions.length + 1
            this.Subjective.questions.push(question)
          } else {
            question['number'] = this.Programming.questions.length + 1
            question['code'] = ''
            question['language'] = 'java'
            question['typeOfResult'] = undefined
            question['submitResult'] = undefined
            this.Programming.questions.push(question)
          }
        }
        this.mcqs.total = this.mcqs.questions.length
        this.Subjective.total = this.Subjective.questions.length
        this.Programming.total = this.Programming.questions.length
        this.loaded = true
        this.mcqs.questions.length === 0 &&
          (this.currentSection = 'Programming')

        if (testee_status === 'NOT_STARTED') {
          let duration_left = response['duration_left']
          this.$store.commit('setTestRestartCount', response['test_restart_count'])
          if (duration_left <= 0) {
            clearInterval(this.$store.state.pingTimer)
            clearInterval(this.$store.state.timer)
            this.$store.commit('setCurrentStep', 'test-ended')
            this.$router.replace({path: '/test-ended'})
          } else {
            this.$store.commit('setDurationLeft', parseInt(duration_left))
            this.startTest = true
          }
        } else if (testee_status === 'CRASHED' || testee_status === 'AUTO_CRASHED') {
          this.startTest = true
          let payload = JSON.parse(response['payload'])
          let answers = payload['answers']
          let duration_left = payload['duration_left']
          this.$store.commit('setDurationLeft', parseInt(duration_left))
          this.$store.commit('setTestRestartCount', response['test_restart_count'])
          for (const answer of answers) {
            if (answer['answer_type'] === 'MCQ') {
              for (var mcq of this.mcqs.questions) {
                if (mcq['_id'] === answer['question_id']['_id']) {
                  //setting the currentClass according to the staus of the question
                  if (answer['answer_state'] === 'Answered') {
                    mcq['currentClass'] = 'saved'
                    this.mcqs.totalSaved = this.mcqs.totalSaved + 1
                  } else if (
                    answer['answer_state'] ===
                    'Marked for Review and Answered'
                  ) {
                    mcq['currentClass'] = 'reviewSubmit'
                    this.mcqs.totalSaved = this.mcqs.totalSaved + 1
                  } else if (
                    answer['answer_state'] ==
                    'Marked For Review and Unanswered'
                  ) {
                    mcq['currentClass'] = 'review'
                  }

                  //setting the answer
                  for (const option of answer['answer']) {
                    mcq['lastSavedAnswer'] = ' ' + option
                    mcq['options'][' ' + option].value = true
                  }
                }
              }
            } else if (answer['answer_type'] === 'Subjective') {
              for (var sub of this.Subjective.questions) {
                if (sub['id'] === answer['question_id']['id']) {
                  //setting the currentClass according to the staus of the question
                  if (answer['answer_state'] === 'Answered') {
                    this.Subjective.totalSaved =
                      this.Subjective.totalSaved + 1
                    sub['currentClass'] = 'saved'
                  } else if (
                    answer['answer_state'] ===
                    'Marked for Review and Answered'
                  ) {
                    this.Subjective.totalSaved =
                      this.Subjective.totalSaved + 1
                    sub['currentClass'] = 'reviewSubmit'
                  } else if (
                    answer['answer_state'] ===
                    'Marked for Review and Unanswered'
                  ) {
                    sub['currentClass'] = 'review'
                  }

                  //setting answer
                  sub['answer'] = answer['answer']
                }
              }
            } else if (answer['answer_type'] === 'Programming') {
              for (var lan_type in answer['code']) {
                sessionStorage.setItem(
                  this.test_id +
                  '.' +
                  this.user_id +
                  '.' +
                  answer['question_id']['id'] +
                  '.' +
                  lan_type,
                  answer['code'][lan_type]
                )
              }
              for (var prog of this.Programming.questions) {
                if (prog['_id'] === answer['question_id']['_id']) {
                  //setting the currentClass according to the staus of the question
                  if (answer['answer_state'] === 'Answered') {
                    this.Programming.totalSaved =
                      this.Programming.totalSaved + 1
                    prog['currentClass'] = 'saved'
                  } else if (
                    answer['answer_state'] ===
                    'Marked for Review and Answered'
                  ) {
                    this.Programming.totalSaved =
                      this.Programming.totalSaved + 1
                    prog['currentClass'] = 'reviewSubmit'
                  } else if (
                    answer['answer_state'] ===
                    'Marked for Review and Unanswered'
                  ) {
                    prog['currentClass'] = 'review'
                  }
                }
              }
            }
          }
        }
    })

    window.onbeforeunload = function () {
      /*Axios.post(
        'https://headstart.infocusp.com/testee/test/' +
          sessionStorage.getItem('test_id') +
          '/user/' +
          sessionStorage.getItem('user_id') +
          '?action=post_endTime'
      ).then(
        response => {
          console.log(response)
        },
        err => {
          console.log(err)
        }
      )*/
      console.log('Trying to close the tab')
      return 'Are you sure you want to leave'
    }

    window.addEventListener('focus', this.onWindowFocusChange);
    window.addEventListener('blur', this.onWindowFocusChange);
    window.addEventListener('pageshow', this.onWindowFocusChange);
    window.addEventListener('pagehide', this.onWindowFocusChange);
    document.fullscreenchange = this.exitHandler
    document.addEventListener('fullscreenchange', this.exitHandler)
    document.addEventListener('onwebkitfullscreenchange', this.exitHandler)
    document.onwebkitfullscreenchange = this.exitHandler
  },
  data: function () {
    return {
      loaded: false,
      currentSection: 'mcqs',
      startTest: false,
      mcqs: {
        total: 0,
        current: 0,
        totalSaved: 0,
        questions: [],
      },
      Subjective: {
        total: 0,
        current: 0,
        totalSaved: 0,
        questions: [],
      },
      Programming: {
        total: 0,
        current: 0,
        totalSaved: 0,
        questions: [],
      },
      showModal: false,
      showSwitchTab: false,
      showSidePanes: true,
      eventVar: '',
      isOnline: true,
      dialog: false,
      inView: true,
      reconnectTime: 10,
    }
  },
  created() {
    window.addEventListener('beforeunload', () => {
        this.$store.commit('setDefaultState')
        console.log("Setting Default State")
        console.log(this.$store.state)
        var testId = this.$route.params.test_id
        var userId = this.$route.params.user_id
        this.$store.commit('setCurrentStep','webcam')
        this.$router.replace({ path: `/webcam/test/${testId}/user/${userId}` })
    })
    if(this.$store.state.currentStep !== 'questions') {
      var testId = this.$route.params.test_id
      var userId = this.$route.params.user_id
      this.$store.commit('setCurrentStep','webcam')
      this.$router.replace({ path: `/webcam/test/${testId}/user/${userId}` })
      return;
    }
    let self = this
    var interval
    this.$store.commit(
      'setPingTimer',
      setInterval(() => {
        api
          .postPing(this.test_id, this.user_id, this.$store.state.testRestartCount)
          .then(response => {
            if (self.isOnline == false) {
              // alert('Error Resolved. You can resume Test')
              self.dialog = false
              self.reconnectTime = 10
              clearInterval(interval)
            }
            self.isOnline = true
            if (
              response['status'] === 'EXTRA_TIME_ADDED' ||
              response['status'] === 'UPDATED'
            ) {
              this.$store.commit('setDurationLeft', response['message'])
            }
            // Test gets ended whenever DL reaches 0, this is written just for extra safety
            else if (response['status'] === 'TIME_COMPLETED') {
              clearInterval(this.$store.state.timer)
              this.endTest(this.$router)
            }
            else if (response['status'] === 'TEST_OPEN_IN_ANOTHER_TAB') {
              clearInterval(this.$store.state.pingTimer)
              this.$store.commit('setDefaultState')
              this.$store.commit('setCurrentStep', 'error')
              this.$router.replace({path: '/error/1'})
            }
          })
          .catch(function (error) {
            console.log(error)
            console.log(error.request)
            if (error.message == 'Network Error') {
              if (self.isOnline == true) {
                // alert('There is some Network Error.Please contact admin')
                self.dialog = true
                interval = setInterval(() => self.countdown(), 1000)
              }
              self.isOnline = false
            }
          })
      }, 10000)
    )
  },
  beforeDestroy() {
    clearInterval(this.$store.state.timer)
    window.onbeforeunload = null
    window.removeEventListener('focus', this.onWindowFocusChange);
    window.removeEventListener('blur', this.onWindowFocusChange);
    window.removeEventListener('pageshow', this.onWindowFocusChange);
    window.removeEventListener('pagehide', this.onWindowFocusChange);
  },
}
</script>

<style scoped>
::-webkit-scrollbar {
  width: 10px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: #464646;
  border-radius: 10px;
}

.questionsPage {
  -webkit-user-select: none; /* webkit (safari, chrome) browsers */
  -moz-user-select: none; /* mozilla browsers */
  -khtml-user-select: none; /* webkit (konqueror) browsers */
  -ms-user-select: none; /* IE10+ */
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  margin-top: 64px;
  justify-content: left;
  background: #f2f2f2;
  max-height: calc(100% - 64px);
}
</style>
